import { render, staticRenderFns } from "./SessionDocuments.vue?vue&type=template&id=4d822db4&"
import script from "./SessionDocuments.vue?vue&type=script&lang=js&"
export * from "./SessionDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports